<schir-int-client-notiz-in-aufgabe-editor [aufgabenTyp]="aufgabenTyp()" />
